export const common = {
    TLINT_SERVER: document.getElementsByName('tlint_server')[0].content,
    TLINT_PORT: document.getElementsByName('tlint_port')[0].content,
    BERT_SERVER: document.getElementsByName('bert_server')[0].content,
    showLoading: function () {
        $(".js-loading").show();
    },
    hideLoading: function () {
        $(".js-loading").hide();
    },
    lintShowLoading: function () {
        $(".js-lint-loading").show();
    },
    lintHideLoading: function () {
        $(".js-lint-loading").hide();
    },
    dialogRepostion: function (dialog) {
        $(dialog).dialog("option", "position", { my: "center", at: "center", of: window });
    }
};

//fontサイズの変更
let base = document.getElementsByTagName('html')[0];
let sizeElements = document.querySelectorAll('.js-size');
let sizeLElements = document.querySelectorAll('.js-size-l');
let sizeMElements = document.querySelectorAll('.js-size-m');
let sizeSElements = document.querySelectorAll('.js-size-s');
function setFontSize(size) {
    base.style.fontSize = size;
}
function addClickListener(elements, size) {
    elements.forEach(function(element) {
        element.addEventListener('click', function () {
            setFontSize(size);
            updateActiveClass(element);
        });
    });
}
addClickListener(sizeLElements, "70%");
addClickListener(sizeMElements, "62.5%");
addClickListener(sizeSElements, "50%");
function updateActiveClass(clickedElement) {
    // すべての .js-size 要素から 'active' クラスを削除
    sizeElements.forEach(function(element) {
        element.classList.remove('active');
    });

    // クリックされた要素と同じサイズの要素に 'active' クラスを追加
    let sizeClass = Array.from(clickedElement.classList).find(cls => cls.startsWith('js-size-'));
    sizeElements.forEach(function(element) {
        if (element.classList.contains(sizeClass)) {
            element.classList.add('active');
        }
    });
}
updateActiveClass(sizeMElements[0]);